import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    GPA_LIST_START: 'GPA_LIST_START',
    GPA_LIST_SUCCESS: 'GPA_LIST_SUCCESS',
    GPA_LIST_FAILED: 'GPA_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const gpaListStart = (data) => ({
   type: actionType.GPA_LIST_START,
   payload: data
})

export const gpaListSuccess = (data) => ({
    type: actionType.GPA_LIST_SUCCESS,
    payload: data
})

export const gpaListFailed = (data) => ({
    type: actionType.GPA_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function gpaListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.GPA_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.GPA_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.GPA_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* gpaListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allGpascales = response.data.data.allGpascales.Gpascales ? response.data.data.allGpascales.Gpascales : null
       yield put(gpaListSuccess(allGpascales));
    } else {
      messagePopup('','GPA List failed','error')   
      yield put(gpaListFailed('GPA List failed')) 
    }
   } catch (error) {
     messagePopup('','GPA List failed','error')   
     yield put(gpaListFailed('GPA List failed')) 
   }
}

export function* watchGpaListSaga(){
    yield takeEvery(actionType.GPA_LIST_START, gpaListSaga)
}